import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=2694495a&scoped=true"
import script from "./SelectCourse.vue?vue&type=script&lang=js"
export * from "./SelectCourse.vue?vue&type=script&lang=js"
import style0 from "./SelectCourse.vue?vue&type=style&index=0&id=2694495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694495a",
  null
  
)

export default component.exports